/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Maxsimultaneouscontacts2Inputs */

const en_entity_maxsimultaneouscontacts2 = /** @type {(inputs: Entity_Maxsimultaneouscontacts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Simultaneous Contacts`)
};

const de_entity_maxsimultaneouscontacts2 = /** @type {(inputs: Entity_Maxsimultaneouscontacts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale gleichzeitige Kontakte`)
};

/**
* | output |
* | --- |
* | "Max Simultaneous Contacts" |
*
* @param {Entity_Maxsimultaneouscontacts2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_maxsimultaneouscontacts2 = /** @type {((inputs?: Entity_Maxsimultaneouscontacts2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Maxsimultaneouscontacts2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_maxsimultaneouscontacts2(inputs)
	return de_entity_maxsimultaneouscontacts2(inputs)
});
export { entity_maxsimultaneouscontacts2 as "entity_maxSimultaneousContacts" }